export default function ShippingAutomation() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="mb-12">
          <div className="inline-block bg-primary text-white px-6 py-3 rounded-lg font-bold text-lg mb-4">
            ⑥ 発送の自動化
          </div>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="bg-gradient-to-br from-primary to-primary-dark text-white rounded-2xl p-8 shadow-lg">
            <h3 className="text-3xl font-bold mb-6">FBA</h3>
            <div className="flex items-center gap-4">
              <i className="ri-check-double-line text-6xl"></i>
              <p className="text-2xl font-bold">ほぼ100%自動</p>
            </div>
            <p className="mt-6 text-lg opacity-90">
              Amazonの倉庫が全て対応
            </p>
          </div>
          
          <div className="bg-white border-2 border-primary rounded-2xl p-8 shadow-lg">
            <h3 className="text-3xl font-bold text-gray-900 mb-6">FBM</h3>
            <div className="space-y-4">
              {[
                { icon: 'ri-file-list-line', text: '注文取得' },
                { icon: 'ri-barcode-line', text: 'ラベル生成' },
                { icon: 'ri-map-pin-line', text: '追跡番号' },
                { icon: 'ri-mail-send-line', text: '顧客通知' }
              ].map((item, index) => (
                <div key={index} className="flex items-center gap-4 bg-gray-50 rounded-lg p-4">
                  <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                    <i className={`${item.icon} text-xl text-primary`}></i>
                  </div>
                  <span className="text-gray-700 font-medium">{item.text}</span>
                  <i className="ri-check-line text-primary text-xl ml-auto"></i>
                </div>
              ))}
            </div>
            <div className="mt-6 bg-primary/5 rounded-lg p-4">
              <p className="text-gray-800 font-bold text-center">
                全部APIで可能。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
